<app-navigation></app-navigation>
<router-outlet></router-outlet>